import { render, staticRenderFns } from "./ErrorsList.vue?vue&type=template&id=3dda1180&scoped=true&lang=pug&"
import script from "./ErrorsList.vue?vue&type=script&lang=js&"
export * from "./ErrorsList.vue?vue&type=script&lang=js&"
import style0 from "./ErrorsList.vue?vue&type=style&index=0&id=3dda1180&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda1180",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VDialog,VIcon})
